import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class Categorys extends Component {

  constructor(props) {
    super(props);
    this.state = {items: []};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.categoryList();
  }

  categoryList() {
    fetch(process.env.REACT_APP_API_URL + '/categories')
      .then( ( response ) => response.json() )
      .then( ( data ) => {
        this.setState({ items: data })
      });
  }

  onDelete(e) {
    e.preventDefault();
    var qId = e.target.dataset.qid;
    fetch(process.env.REACT_APP_API_URL + '/categories/' + qId + '/delete', {
        method: 'POST'
      })
      .then( ( response ) => response.json() )
      .then( ( data ) => {
        this.categoryList();
      });
  }

  render() {
    console.log(this.state.items);
    const items = this.state.items.map((item, i) => (
        <tr key={i}>
          <td>{ item.name }</td>
          <td>{ item.code }</td>
          <td>{ item.questions.length }</td>
          <td className="text-right">
            <Link to={"/categories/" + item._id + "/edit"} className="btn btn-sm btn-primary">Editar</Link>
            &nbsp;&nbsp;
            <button onClick={ this.onDelete } data-qid={item._id} className="btn btn-sm btn-danger">Eliminar</button>
          </td>
        </tr>
    ));
    return (
      <div id="categories" className="container">
        <table className="table table-stripped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Questions</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            { items }
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/Categories.jsx